import { http } from '../utilities';

const getUser = async (name) => {
  return await http(`http://rs.christieman.com/api/?username=${name}`);
};

export default { getUser };



// WEBPACK FOOTER //
// ./src/services/api.js